import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { Suspense } from 'react';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ThemeProvider>
        <AuthProvider>
          <PermissionsProvider>
            <Suspense
              fallback={
                <div className="min-h-screen bg-white flex items-center justify-center">
                  <div className="text-center">
                    <i className="ri-loader-4-line text-5xl text-teal-600 animate-spin"></i>
                    <p className="mt-4 text-gray-600 text-lg">Carregando DeuConta...</p>
                  </div>
                </div>
              }
            >
              <AppRoutes />
            </Suspense>
          </PermissionsProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
